import api from './config';

/**
 * Notification endpoints — token registration + per-notification preferences.
 * Contract matches racore-back custom routes (notification-token /
 * notification-preference controllers).
 */

export type NotificationDeviceType = 'ios' | 'android' | 'web';

export interface NotificationTokenPayload {
  token: string;
  device_type: NotificationDeviceType;
  app_version?: string;
}

export interface NotificationPreferences {
  /** Notification 2 — Racore daily digest (08:00). */
  daily_recommendations: boolean;
  /** Notification 1 — immediate push on a new reco in my circles. */
  new_recommendations: boolean;
  /** Immediate push when someone reacts to or rebounds one of my recos. */
  author_digest: boolean;
}

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  daily_recommendations: true,
  new_recommendations: true,
  author_digest: true,
};

export const registerNotificationToken = async (payload: NotificationTokenPayload) => {
  const { data } = await api.post('/notification-tokens/register', payload);
  return data?.data ?? data;
};

export const unregisterNotificationToken = async (token: string) => {
  const { data } = await api.post('/notification-tokens/unregister', { token });
  return data?.data ?? data;
};

export const getNotificationPreferences = async (): Promise<NotificationPreferences> => {
  const { data } = await api.get('/notification-preferences/my-preferences');
  const prefs = data?.data ?? data;
  return { ...DEFAULT_NOTIFICATION_PREFERENCES, ...prefs };
};

export const updateNotificationPreferences = async (
  update: Partial<NotificationPreferences>,
): Promise<NotificationPreferences> => {
  const { data } = await api.put('/notification-preferences/my-preferences', update);
  const prefs = data?.data ?? data;
  return { ...DEFAULT_NOTIFICATION_PREFERENCES, ...prefs };
};
